import { z } from 'zod';

export const ApiAppConfigZod = z.object({
  environment: z.string(),
  oktaClientId: z.string(),
  oktaIssuerUri: z.string(),
  version: z.string(),
});
export type ApiAppConfig = z.infer<typeof ApiAppConfigZod>;
